export default class Link {
  constructor(public icon: string, public href: string) {}
}
